/**
 * Environment configuration.
 * Centralizes access to all environment variables.
 */
export const env = {
  /** Base URL for the backend API */
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || "http://localhost:3000",

  /**
   * Base URL for the legacy backend API.
   * The original Java EE backend at ventas.ticketin.ec.
   */
  legacyApiBaseUrl:
    import.meta.env.VITE_LEGACY_API_BASE_URL ||
    "https://ventas.ticketin.ec/ticketIn/rest",

  /** API mode: 'mock' uses local mock data, 'production' hits the real API */
  apiMode: (() => {
    console.log("ENV VALUE:", import.meta.env.VITE_API_MODE);
    return (import.meta.env.VITE_API_MODE || "mock") as "mock" | "production";
  })(),
  /** Whether we are in development mode */
  isDev: import.meta.env.DEV,

  /** Whether we are in production mode */
  isProd: import.meta.env.PROD,

  // ── Firebase ──
  firebaseApiKey: import.meta.env.VITE_FIREBASE_API_KEY || "",
  firebaseAuthDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "",
  firebaseProjectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "",
  firebaseStorageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "",
  firebaseMessagingSenderId:
    import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "",
  firebaseAppId: import.meta.env.VITE_FIREBASE_APP_ID || "",
  firebaseMeasurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "",

  /**
   * Meta Pixel id. Empty means the pixel is not loaded at all — that is the intended state for
   * local development. It must also be set in `.gitlab-ci.yml`, which writes `.env.production`
   * line by line.
   */
  metaPixelId: import.meta.env.VITE_META_PIXEL_ID || "",

  /** Tenant identifier for mobile API paths (e.g., GET {tenantId}/eventos) */
  tenantId: import.meta.env.VITE_TENANT_ID || "ticketin",

  /** WAF token required by the AWS ALB on every request */
  apiToken: import.meta.env.VITE_API_TOKEN || "",

  // ── PayPhone ──
  payPhoneTokenAuth: import.meta.env.VITE_PAYPHONE_TOKEN_AUTH || "",
  payPhoneStoreId: import.meta.env.VITE_PAYPHONE_STORE_ID || "",

  // ── Plux (PagoPlux) ──
  /** Correo del comercio registrado en Plux. Placeholder vacío hasta el onboarding. */
  pluxComercioEmail: import.meta.env.VITE_PLUX_COMERCIO_EMAIL || "",
  /** Sandbox por defecto (false); producción se activa por config/env, nunca hardcode. */
  pluxProduction: import.meta.env.VITE_PLUX_PRODUCTION === "true",

  // ── Sentry ──
  sentryDsn: import.meta.env.VITE_SENTRY_DSN || "",
} as const;
